import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import Button from "material-ui/Button";
import Typography from "material-ui/Typography";

import Wrapper from "../../../common/Wrapper";
import Header from "../../../common/Header";
import ContactInfoInner from "../../../SendLetter/dialogs/ContactInfoInner";
import Loader from "../../../Parts/Loader";

import NotificationBar from "../../../Parts/NotificationBar.jsx";

import ProgressBar from "../common/ProgressBar";
import SalesforceExeExportMapping from "./SalesforceExeExportMapping";
import SalesforceSettingComplete from "../common/SalesforceSettingComplete";
import SalesforceSelectObject from "../SalesforceAddressSetting/SalesforceSelectObject";

import {
  SalesforceExeSettingStep,
  salesforceExeExportMappingFormProps,
  salesforceExeSettingSteps,
  DialogType,
  SalesforceSettingDirectory,
} from "../../../../constants/ComponentTypes";
import { defaultSalesforceExeExportMapping } from "../../../../constants/SalesforceMapping.js";
import { makeSalesforceExportMap } from "../../../../utils/utils";

const { Map } = require("immutable");

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },

  overview: {
    background: "#F4F6F9",
    flex: 1,
    width: "80%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    maxWidth: "1200px",
    margin: "auto",
    padding: "20px",
    boxSizing: "border-box",
  },

  progressbar: {
    marginTop: "22px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  cancelBtn: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: "15px 23px 0px 0px",
    padding: "8px 15px",
    fontSize: "13px",
    minWidth: "unset",
    minHeight: "unset",
  },

  box: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "36px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

class SalesforceExeSetup extends React.Component {
  state = {
    sobject_name: 0,
    step: SalesforceExeSettingStep.SELECT_OBJECT,
    showNotification: false,
    message: "",
    messageType: "success",
    mapping: Map(),
  };

  componentDidMount() {
    this.props.getUserInfo();
    this.props.getSalesforceDescribeExeExport();
    this.props.getSalesforceConfig();

    let mapping = this.state.mapping;
    salesforceExeExportMappingFormProps.forEach((prop) => {
      mapping = mapping.set(prop.key, {});
    });
    this.setState({
      mapping: mapping,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.successMessage && nextProps.successMessage !== "") {
      this.displayNotification(nextProps.successMessage, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== "") {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== "") {
      this.displayNotification(nextProps.shortMessage, "green");
    }

    // 設定済みの場合、設定画面にリダイレクト
    if (this.props.isLoadingConfig && !nextProps.isLoadingConfig) {
      if (nextProps.exe_export_mappings_flag) {
        nextProps.replace(SalesforceSettingDirectory.EXE_LIST.setting_path);
      }
    }
  }

  /*** toggle funcions ***/
  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  /*** handlers ***/
  goToStep = (step) => {
    this.setState({ step: step });
  };

  handleUpdateMapping = (mapping) => {
    this.setState({
      mapping: mapping,
    });
  };

  handleSelectSobject = (e) => {
    this.setState({
      sobject_name: e.target.value,
      mapping: makeSalesforceExportMap(
        defaultSalesforceExeExportMapping[e.target.value]
      ),
    });
  };

  /*** render functions ***/
  renderNotification = () => {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          top: 10,
          width: "98%",
          left: "1%",
        }}
      >
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false });
          }}
          autoClose={false}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : "100%",
          }}
        ></NotificationBar>
      </div>
    );
  };

  renderLoading = () => (
    <div className={this.props.classes.overview}>
      <div className={this.props.classes.box}>
        <Loader type="color" />
      </div>
    </div>
  );

  renderContactBox = () => (
    <div className={this.props.classes.overview}>
      <div className={this.props.classes.box}>
        <Typography variant="title" className={this.props.classes.sectionTitle}>
          現在ご利用のプランでは、Salesforce連携機能がサポートされていません
        </Typography>

        <ContactInfoInner />
      </div>
    </div>
  );

  renderAuthorizeBox = () => {
    const { classes } = this.props;

    return (
      <div className={classes.overview}>
        <div className={classes.box} style={{ minHeight: "unset" }}>
          <Typography variant="subheading">
            認証情報が見つかりません。
            <a
              href={
                process.env.REACT_APP_API_BASE_URL +
                "/oauth2/salesforce?redirect_url=" +
                process.env.REACT_APP_FRONTEND_URL +
                "/setting/integrations/salesforce"
              }
              target="_self"
              className={classes.link}
            >
              こちら
            </a>
            より設定してください。
          </Typography>
        </div>
      </div>
    );
  };

  renderMapping = () => (
    <SalesforceExeExportMapping
      step={this.state.step}
      type={DialogType.CREATE}
      sobject={this.state.sobject_name}
      mapping={this.state.mapping}
      updateMapping={this.handleUpdateMapping}
      isLoadingFields={this.props.isLoadingFields}
      isConfiguring={this.props.isConfiguring}
      accountFields={this.props.accountFields}
      contactFields={this.props.contactFields}
      leadFields={this.props.leadFields}
      goToStep={this.goToStep}
      postSalesforceExportMappingsExe={
        this.props.postSalesforceExportMappingsExe
      }
    />
  );

  renderSelectObject = () => (
    <SalesforceSelectObject
      sobject={this.state.sobject_name}
      next={() => this.goToStep(SalesforceExeSettingStep.MAPPING)}
      handleSelectSobject={this.handleSelectSobject}
      isLoading={
        this.props.isLoadingFields || this.props.isLoadingFields.isLoadingConfig
      }
      menu={[
        { value: "Contact", text: "取引先・取引先責任者" },
        { value: "Lead", text: "リード" },
      ]}
    />
  );

  render() {
    const { classes, isLoadingFields, isLoadingConfig } = this.props;

    let notification;
    if (this.state.showNotification) {
      notification = this.renderNotification();
    }

    return (
      <Wrapper className={classes.root}>
        <Header
          title="Salesforce連携設定"
          secondaryTitle="キーマンデータベース連携設定"
          type="dark"
          hasBackBtn={false}
          onTitleClicked={() =>
            this.props.goTo("/setting/integrations/salesforce")
          }
        />
        <div className={classes.content}>
          {(() => {
            if (this.props.user) {
              if (!this.props.user.salesforce_integration_flag) {
                return this.renderContactBox();
              } else if (!this.props.user.integrations.salesforce) {
                return this.renderAuthorizeBox();
              } else if (isLoadingFields || isLoadingConfig) {
                return this.renderLoading();
              } else {
                if (
                  this.state.step === SalesforceExeSettingStep.SETTING_COMPLETE
                ) {
                  return (
                    <SalesforceSettingComplete
                      goTo={this.props.goTo}
                      type={SalesforceSettingDirectory.EXE_LIST.value}
                      dialogType={DialogType.CREATE}
                      isImporting={this.props.isImporting}
                    />
                  );
                } else {
                  return (
                    <div>
                      <div className={classes.progressbar}>
                        <ProgressBar
                          step={this.state.step}
                          steps={salesforceExeSettingSteps}
                        />
                        <Button
                          className={classes.cancelBtn}
                          onClick={() => {
                            if (
                              window.confirm(
                                "設定をキャンセルします。よろしいですか？"
                              )
                            ) {
                              this.props.goTo(
                                "/setting/integrations/salesforce"
                              );
                            }
                          }}
                        >
                          キャンセル
                        </Button>
                      </div>
                      {this.state.step ===
                        SalesforceExeSettingStep.SELECT_OBJECT
                        ? this.renderSelectObject()
                        : this.renderMapping()}
                    </div>
                  );
                }
              }
            }
          })()}
        </div>
        {notification}
      </Wrapper>
    );
  }
}

SalesforceExeSetup.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  message: PropTypes.string,
  messageType: PropTypes.string,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  isLoadingFields: PropTypes.bool,
  isLoadingConfig: PropTypes.bool,
  isConfiguring: PropTypes.bool,
  isImporting: PropTypes.bool,
  accountFields: PropTypes.object,
  contactFields: PropTypes.object,
  leadFields: PropTypes.object,
  exe_export_mappings_flag: PropTypes.bool,
  goTo: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  getSalesforceDescribeExeExport: PropTypes.func.isRequired,
  getSalesforceConfig: PropTypes.func.isRequired,
  postSalesforceExportMappingsExe: PropTypes.func.isRequired,
  postSalesforceSync: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
};

export default withStyles(styles)(SalesforceExeSetup);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceExeSetting/SalesforceExeSetup.jsx